module.exports = __webpack_public_path__ + "img/Farm-U.0f5b4e58.png";